/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsrecht8Inputs */

const en__field_enum_mzsrecht8 = /** @type {(inputs: _Field_Enum_Mzsrecht8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jurisprudence`)
};

const de__field_enum_mzsrecht8 = /** @type {(inputs: _Field_Enum_Mzsrecht8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtswissenschaft`)
};

/**
* | output |
* | --- |
* | "jurisprudence" |
*
* @param {_Field_Enum_Mzsrecht8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsrecht8 = /** @type {((inputs?: _Field_Enum_Mzsrecht8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsrecht8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsrecht8(inputs)
	return de__field_enum_mzsrecht8(inputs)
});
export { _field_enum_mzsrecht8 as "_field_enum_MZSRECHT" }